import React from 'react'
import {Box} from '@mui/material'
import {Icon, ReadOnlyPipeSeprated} from '@/components/atoms'
import './_overViewSubHeader.scss'
/**
 * OverViewSubHeader component displays a header with an icon and a list of labeled items.
 *
 * @param {Object} props - The component props.
 * @param {string} props.id - The id for the Box component.
 * @param {Array} props.items - The array of items to display, each item should have a `label` and `value` property.
 *
 * @returns {JSX.Element} The rendered OverViewSubHeader component.
 */
const OverViewSubHeader = ({id, items}) => {
  return (
    <Box id={id} className={`flex items-center pb-4 pt-2`}>
      <Icon className="ovsh-icon-color" icon={'verified_user'} size={'small'} />
      {items?.map((obj, index) => (
        <div key={index} className={`flex items-center `}>
          <ReadOnlyPipeSeprated
            isRightBorderVisible={!(items.length - 1 === index)}
            label={obj.label}
            value={obj.value}
            id={index}
          />
        </div>
      ))}
    </Box>
  )
}
export default OverViewSubHeader
